// import React, { useState } from 'react'
// import { RiCollapseDiagonalLine } from "react-icons/ri";
// import { IoIosArrowDown } from "react-icons/io";
// import { IoIosArrowUp } from "react-icons/io";
// import { FaFilter } from "react-icons/fa";
// import { TbReload } from "react-icons/tb";
// import { TbArrowsSort } from "react-icons/tb";
// import { IoIosArrowForward } from "react-icons/io";
// import { MdDelete } from "react-icons/md";
// import { FaCogs } from "react-icons/fa";
// import AgentChatConfigurationsModal from './AgentChatConfigurationsModal';
// import { RiAddLargeFill } from "react-icons/ri";
// import { IoSaveSharp } from "react-icons/io5";
// import { FaEye } from "react-icons/fa";
// import { FaEyeSlash } from "react-icons/fa";
// import { PiSignInBold } from "react-icons/pi";

// import AddAgent from './AddAgent';


// function decodeToken(token) {
//     if (!token) return {};
//     try {
//         const base64Url = token.split('.')[1]
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64)
//                 .split('')
//                 .map(function (c) {
//                     return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
//                 })
//                 .join('')
//         );
//         return JSON.parse(jsonPayload);
//     } catch (e) {
//         return {};
//     }
// }

// // Prefer using the same mechanism as in ClientList.jsx to get userId
// function getUserIdFromTokenOrLocatorgarsotrga() {
//     // Try global locatorgarsotrga if available
//     if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
//         const rawToken = window.locatorgarsotrga("token");
//         if (rawToken) {
//             const decoded = decodeToken(rawToken);
//             const userId = decoded.id || decoded.userId || decoded._id;
//             return { userId, token: rawToken };
//         }
//     }
//     // Fallback to localStorage (if locatorgarsotrga is not set)
//     const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
//     if (rawToken) {
//         const decoded = decodeToken(rawToken);
//         const userId = decoded.id || decoded.userId || decoded._id;
//         return { userId, token: rawToken };
//     }
//     return { userId: null, token: null };
// }



// function AgentList() {
//     const [showfilter, setshowfilter] = useState(false)
//     const [Name, setName] = useState('')
//     const [Number, setNumber] = useState('')
//     const [Configurations, setConfigurations] = useState([]);
//     const [Channel, setChannel] = useState('')
//     const [Attribute, setAttribute] = useState('')
//     const [Status, setStatus] = useState(false)
    


//     const initialUsers = [
//         {
//             id: 1,
//             name: "blueberry1",
//             phone: "917597312485",
//             email: "ravim@blueberry-travel.com",
//             RegistrationDate: "03 Feb 2026 02:40:17 PM",
//             ExpiryDate: "31 Dec 2026 12:00:00 AM",

//         },
//         {
//             id: 2,
//             name: "Zoope_Retail",
//             phone: "919587556336",
//             email: "lokeshjajoria222@gmail.com",
//             RegistrationDate: "03 Feb 2026 02:40:17 PM",
//             ExpiryDate: "31 Dec 2026 12:00:00 AM",
//         },
//         {
//             id: 3,
//             name: "BBGDMCC",
//             phone: "919024233321",
//             email: "Bhupendra.blueberry@gmail.com",
//             RegistrationDate: "03 Feb 2026 02:40:17 PM",
//             ExpiryDate: "31 Dec 2026 12:00:00 AM",
//         },
//         {
//             id: 4,
//             name: "Gurpreet",
//             phone: "919216058711",
//             email: "Gurpreet.kaur@aadviktech.com",
//             RegistrationDate: "03 Feb 2026 02:40:17 PM",
//             ExpiryDate: "31 Dec 2026 12:00:00 AM",
//         },
//         {
//             id: 5,
//             name: "Abiee",
//             phone: "917301020313",
//             email: "business@aadviktech.com",
//             RegistrationDate: "03 Feb 2026 02:40:17 PM",
//             ExpiryDate: "31 Dec 2026 12:00:00 AM",
//         }
//     ];
//     const [users, setUsers] = useState(initialUsers);


//     const chatAssign = (id) => {
//         setUsers((prev) =>
//             prev.map((user) =>
//                 user.id === id
//                     ? { ...user, AllChatAssign: !user.AllChatAssign }
//                     : user
//             )
//         );
//     };

//     const [open, setopen] = useState(false)


//     function addAttributes() {
//         if (!Attribute.trim()) return;

//         const newAttributes = {
//             id: Configurations.length + 1,
//             Attribute: Attribute,
//             Status: Status
//         };
//         setConfigurations((prev) => [...prev, newAttributes]);
//         setChannel('');
//         setAttribute('');
//         setopen(false);
//     }

//     console.log(Configurations)

//     const deleteitem = (id) => {
//         const upadateusers = users.filter((item) => (
//             item.id !== id
//         ))
//         setUsers(upadateusers)
//     }

//     const [currentPage, setcurrentPage] = useState(1);
//     const [usersperpage, setuserperpages] = useState(10);

//     const indexoflastuser = currentPage * usersperpage;
//     const indexoffirstuser = indexoflastuser - usersperpage
//     const filteruser = users.slice(indexoffirstuser, indexoflastuser)
//     const totalpages = Math.ceil(users.length / usersperpage)

//     const [ShowAttributes, setshowAttributes] = useState(false)

//     const [AddAgentOpen, setAddAgentOpen] = useState(false)

//     const [showpasword, setshowpasword] = useState(false)
//     const initialState = {
//         AgentName: "",
//         password: "",
//         mobile: "",
//         email: "",
//         expiryDate: ""

//     };

//     const [formData, setFormData] = useState(initialState);

//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         setFormData({
//             ...formData,
//             [name]: value
//         });
//     };
//     const handleSubmit = () => {
//         const { AgentName, password, mobile, email, expiryDate } = formData;

//         if (
//             !AgentName ||
//             !password ||
//             !mobile ||
//             !email ||
//             !expiryDate

//         ) {
//             alert("All fields are required!");
//             return;
//         }

//         console.log("Form Data:", formData);
//         setAddAgentOpen(false)
//         setFormData(initialState);
//     };

//     return (
//         <>
//             <div className=' px-2 dark:bg-[#121519] h-[100vh] px-4'>
//                 <div className='border-b-[1px] border-[#cfcdcd] pb-1 '>
//                     <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>Agent List</h1>
//                     <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  <span>Home</span> <IoIosArrowForward />
//                         <span>Agent List</span> </div>
//                 </div>
//                 <button
//                     onClick={() => setAddAgentOpen(true)}
//                     className='bg-[#448c74] text-[#fff] text-[13px] font-semibold flex items-center gap-2 rounded-md p-2 mt-2'>
//                     <RiAddLargeFill className='font-bold text-[16px]' />
//                     Add Agent
//                 </button>
//                 <div onClick={() => setshowfilter(!showfilter)}
//                     className='w-[100%] flex justify-between  px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4'>
//                     <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
//                         <RiCollapseDiagonalLine />
//                         Filter Records
//                     </div>
//                     <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
//                         {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
//                     </div>
//                 </div>
//                 {showfilter &&
//                     <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519] z-20'>
//                         <div className='w-[100%] flex flex-wrap gap-4'>

//                             <div className='w-full sm:w-[48%] lg:w-[32%] flex flex-col gap-1'>
//                                 <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Agent Name:</label>
//                                 <input
//                                     value={Name}
//                                     onChange={(e) => setName(e.target.value)}
//                                     className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                     placeholder='Enter User Name'
//                                     type="text"
//                                 />
//                             </div>
//                             <div className='w-full sm:w-[48%] lg:w-[32%] flex flex-col gap-1'>
//                                 <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Agent Number:</label>
//                                 <input
//                                     value={Number}
//                                     onChange={(e) => setNumber(e.target.value)}
//                                     className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                     placeholder='Enter Mobile Number'
//                                     type="text"
//                                 />
//                             </div>
//                             <div className='w-full sm:w-[48%] lg:w-[32%] flex items-center gap-1 mt-4'>
//                                 <button

//                                     className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'
//                                 >
//                                     <FaFilter /> <span className='text-[12px] font-bold'>Filter</span>
//                                 </button>

//                                 <button
//                                     className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
//                                 >
//                                     <TbReload /> <span className='text-[12px] font-bold'>Clear Filter</span>
//                                 </button>
//                             </div>

//                         </div>
//                     </div>
//                 }
//                 <table className="w-full   overflow-hidden border-[1px] border-[#dee2e6] relative ">
//                     <thead className="">
//                         <tr className="text-left text-sm font-semibold text-gray-700">
//                             <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Name</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>
//                             <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Number</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>
//                             <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Email</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>
//                             <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Registration Date</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>

//                             <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Account Expiry Date</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>
//                             <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[11px] text-[#576071] dark:text-[#fff]'>All Chat Assign</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>
//                             <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Action</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {filteruser.length > 0 ? (
//                             filteruser.map((user) => (
//                                 <tr
//                                     key={user.id}
//                                     className=" text-gray-500 odd:bg-white even:bg-[#edf1f5] 
//         dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#edf1f5]"
//                                 >
//                                     <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">{user.name}</td>
//                                     <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">{user.phone}</td>
//                                     <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">{user.email}</td>
//                                     <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">{user.RegistrationDate}</td>
//                                     <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">{user.ExpiryDate}</td>
//                                     <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">
//                                         <button
//                                             onClick={() =>
//                                                 chatAssign(user.id)
//                                             }
//                                             className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${user.AllChatAssign ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}
//                                         >
//                                             <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${user.AllChatAssign ? "translate-x-[13px]" : ""}`}></div>
//                                         </button>
//                                     </td>
//                                     <td className="p-1 text-[11px] border-[1px] flex gap-1 items-center border-[#dee2e6] dark:text-[#fff] ">
//                                         <button
//                                             onClick={() => deleteitem(user.id)}
//                                             className='p-1 border-[1px] border-[#ed5050] rounded-md text-[#ed5050] hover:text-[#fff] hover:bg-[#ed5050]'><MdDelete /></button>
//                                         <button
//                                             onClick={() => setopen(true)}
//                                             className='p-1 border-[1px] border-[#448c74] rounded-md text-[#448c74] hover:text-[#fff] hover:bg-[#448c74]'><FaCogs /></button>
//                                         <button
                                            
//                                             className='p-1 border-[1px] border-[#121519] rounded-md text-[#121519] hover:text-[#fff] hover:bg-[#121519]'><PiSignInBold /></button>
//                                     </td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
//                                 <td colSpan="7" className="p-1 text-[11px]">
//                                     No data found
//                                 </td>
//                             </tr>

//                         )}
//                     </tbody>
//                 </table>
//                 <div className='flex justify-between w-[100%] '>
//                     <p className='text-[11px] text-[#3f7fc8] mt-2' >Showing {indexoffirstuser} to {indexoflastuser} of {users.length} records</p>
//                     <div className="flex justify-center mt-4 space-x-3 relative z-0">
//                         <button
//                             disabled={currentPage === 1}
//                             onClick={() => setcurrentPage((prev) => prev - 1)}
//                             className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition "
//                         >
//                             Prev
//                         </button>

//                         {/* {Array.from({length: Math.ceil(users.length /usersperpage )}).map((_, index)=>
                  
//                   <button key={index}
//                   onClick={()=> setcurrentPage(index + 1)}
//                   className={`${currentPage === index + 1 ? 'bg-[#448c74] text-[#fff]':'bg-gray-200 '} px-2`}
//                   >
//                    {index + 1}
//                   </button>
//                )

//                } */}


//                         {<p className='text-[11px] text-[#3f7fc8] mt-2' > {currentPage} page of  {totalpages}  pages</p>

//                         }

//                         <button
//                             disabled={currentPage === Math.ceil(users.length / usersperpage)}
//                             onClick={() => setcurrentPage((prev) => prev + 1)}
//                             className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
//                         >
//                             Next
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             <AgentChatConfigurationsModal isOpen={open} onClose={() => setopen(false)} heading={'Agent Chat Configurations'}>
//                 <div className='border-t-[1px] border-[#e3e9ef] w-[100%]'>
//                     <button
//                         onClick={() => setshowAttributes(true)}
//                         className='bg-[#448c74] text-[#fff] text-[13px] font-semibold flex items-center gap-2 rounded-md p-2 mt-2'>
//                         <RiAddLargeFill className='font-bold text-[16px]' />
//                         Add Attribute
//                     </button>
//                 </div>
//                 {ShowAttributes &&
//                     <div className='border-[1px] p-2 border-[#dee2e6] rounded-md mt-2'>
//                         <div className='w-[100%] py-2 bg-[#f6f9fc] flex justify-center items-center'>
//                             <h1 className='text-[#000] text-[16px] font-semibold'>User Attributes</h1>
//                         </div>
//                         <div className='mt-2'>
//                             <label htmlFor="" className='text-[#121519] text-[13px] font-semibold'> Channel</label>
//                             <select name="" id="" className='border-[1px] text-[#121519] border-[#d4cfcf] w-[100%] rounded-lg p-1 outline-none'
//                             >
//                                 <option value="">Select Channel</option>
//                             </select>
//                         </div>
//                         <div className='mt-2'>
//                             <label htmlFor="" className='text-[#121519] text-[13px] font-semibold'> Attribute</label>
//                             <input type="text" className='border-[1px] border-[#d4cfcf] w-[100%] rounded-lg p-1 outline-none'
//                                 placeholder='Var1'
//                             />
//                         </div>
//                         <div className='mt-2 flex gap-2 items-center'>
//                             <span className='text-[#121519] text-[13px] font-semibold'> Status</span>
//                             <button
//                                 onClick={() =>
//                                     setStatus(!Status)
//                                 }
//                                 className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${Status ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}
//                             >
//                                 <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${Status ? "translate-x-[13px]" : ""}`}></div>
//                             </button>
//                         </div>
//                         <div className='w-[100%] flex items-center justify-end'>
//                             <button
//                                 onClick={addAttributes}
//                                 className='bg-[#37715d] p-2 rounded-md text-[#fff] text-[12px] flex items-center gap-1 font-semibold'> <IoSaveSharp />
//                                 Save</button>
//                         </div>
//                     </div>
//                 }


//                 <table className="w-full   overflow-hidden border-[1px] border-[#dee2e6] relative  mt-4">
//                     <thead className="">
//                         <tr className="text-left text-sm font-semibold text-gray-700">
//                             <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Attributes</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>
//                             <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Created Date</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>
//                             <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Status</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>
//                             <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
//                                 <div className="flex justify-between items-center gap-2">
//                                     <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Action</span>
//                                     <button type="button" className="text-gray-500 hover:text-black">
//                                         <TbArrowsSort />
//                                     </button>
//                                 </div>
//                             </th>
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {Configurations.length > 0 ? (
//                             Configurations.map((user) => (
//                                 <tr
//                                     key={user.id}
//                                     className=" text-gray-500 odd:bg-white even:bg-[#edf1f5] 
//         dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#edf1f5]"
//                                 >
//                                     <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">{user.Attribute}</td>
//                                     <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] "></td>
//                                     <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">{user.Status}</td>

//                                     <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]"></td>

//                                 </tr>
//                             ))
//                         ) : (
//                             <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
//                                 <td colSpan="7" className="p-1 text-[11px]">
//                                     No data found
//                                 </td>
//                             </tr>

//                         )}
//                     </tbody>
//                 </table>

//             </AgentChatConfigurationsModal>
//             <AddAgent isOpen={AddAgentOpen} onClose={() => setAddAgentOpen(false)} heading={'Add Agent'}>
//                 <div className=' py-1 px-4 w-[100%] dark:bg-[#121519]'>
//                     <div className='w-[100%] flex flex-wrap gap-2'>
//                         <div className='w-full  flex flex-col gap-1'>
//                             <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Agent Name</label>
//                             <input
//                                 name='AgentName'
//                                 value={formData.userName}
//                                 onChange={handleChange}
//                                 placeholder='Enter User name'
//                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                 type="text"
//                             />
//                         </div>
//                         <div className='w-full  flex  gap-1'>
//                             <div className='flex flex-col w-[100%]'>
//                                 <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Password</label>
//                                 <div className='flex justify-between border-[#d4cfcf] border-[1px] rounded-md w-[100%] py-1'>
//                                     <input
//                                         name='password'
//                                         value={formData.password}
//                                         onChange={handleChange}
//                                         placeholder='Enter Password'
//                                         className='text-[#454546]  text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                         type={showpasword ? 'text' : 'password'}
//                                     />
//                                     <div className='border-l-[1px] border-[#d4cfcf] p-2 text-[#454546] '>
//                                         {showpasword ? <FaEye onClick={() => { setshowpasword(!showpasword) }} /> : <FaEyeSlash onClick={() => { setshowpasword(!showpasword) }} />}
//                                     </div>
//                                 </div>
//                             </div>

//                         </div>
//                         <div className='w-full  flex flex-col gap-1'>
//                             <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Mobile Number</label>
//                             <input
//                                 name='mobile'
//                                 value={formData.mobile}
//                                 onChange={handleChange}
//                                 placeholder='Enter Mobile Number'
//                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                 type="text"
//                             />
//                         </div>
//                         <div className='w-full  flex flex-col gap-1'>
//                             <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>EmailId</label>
//                             <input
//                                 name='email'
//                                 value={formData.email}
//                                 onChange={handleChange}
//                                 placeholder='Enter Email Address'
//                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                 type="text"
//                             />
//                         </div>
//                         <div className='w-full  flex flex-col gap-1'>
//                             <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Account Expiry Date</label>
//                             <input
//                                 name='expiryDate'
//                                 value={formData.expiryDate}
//                                 onChange={handleChange}
//                                 placeholder='Enter Email Address'
//                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                 type="date"
//                             />
//                         </div>

//                         <div className='w-full  flex items-center justify-end gap-1 mt-4'>
//                             <button
//                                 onClick={handleSubmit}
//                                 className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2  gap-2 bg-[#37715d] text-[#fff] w-full sm:w-auto'
//                             >
//                                 <span className='text-[12px] font-bold'>Save</span>
//                             </button>

//                             <button
//                                 onClick={() => {
//                                     setAddAgentOpen(!open)
//                                 }}
//                                 className='flex items-center justify-end border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
//                             >
//                                 <span className='text-[12px] font-bold'>Close</span>
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </AddAgent>
//         </>
//     )
// }

// export default AgentList











import React, { useState, useEffect } from 'react'
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { TbArrowsSort } from "react-icons/tb";
import { IoIosArrowForward } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { FaCogs } from "react-icons/fa";
import AgentChatConfigurationsModal from './AgentChatConfigurationsModal';
import { RiAddLargeFill } from "react-icons/ri";
import { IoSaveSharp } from "react-icons/io5";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { PiSignInBold } from "react-icons/pi";
import AddAgent from './AddAgent';
const API_URL = process.env.REACT_APP_API_URL || "https://wa-api.globebot.io";
// ─── Token helpers ────────────────────────────────────────────────────────────

function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (e) {
        return {};
    }
}

function getAuthFromStorage() {
    const rawToken =
        (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function'
            ? window.locatorgarsotrga("token")
            : null)
        ?? localStorage.getItem('token');

    if (!rawToken) return { userId: null, token: null };

    const decoded = decodeToken(rawToken);
    const userId = decoded.id || decoded.userId || decoded._id || null;
    return { userId, token: rawToken };
}

// ─── Component ────────────────────────────────────────────────────────────────

function AgentList() {
    // ── filter state ──────────────────────────────────────────────────────────
    const [showfilter, setshowfilter] = useState(false);
    const [filterName, setFilterName] = useState('');
    const [filterNumber, setFilterNumber] = useState('');

    // ── agent / table state ───────────────────────────────────────────────────
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetchError, setFetchError] = useState(null);

    // ── pagination ────────────────────────────────────────────────────────────
    const [currentPage, setcurrentPage] = useState(1);
    const [usersperpage] = useState(10);

    // ── configurations modal ──────────────────────────────────────────────────
    const [open, setopen] = useState(false);
    const [Configurations, setConfigurations] = useState([]);
    const [ShowAttributes, setshowAttributes] = useState(false);
    const [Attribute, setAttribute] = useState('');
    const [Channel, setChannel] = useState('');
    const [Status, setStatus] = useState(false);

    // ── add agent modal ───────────────────────────────────────────────────────
    const [AddAgentOpen, setAddAgentOpen] = useState(false);
    const [showpasword, setshowpasword] = useState(false);
    const [addLoading, setAddLoading] = useState(false);

    const initialState = { AgentName: '', password: '', mobile: '', email: '', expiryDate: '' };
    const [formData, setFormData] = useState(initialState);

    // ─── Fetch agents from API ────────────────────────────────────────────────
    const { userId, token } = getAuthFromStorage();

    const fetchAgents = async () => {
        setLoading(true);
        setFetchError(null);
        try {
            const res = await fetch(`${API_URL}/auth/allusersinfo`, {
                headers: {
                    'Content-Type': 'application/json',
                    ...(token ? { Authorization: `Bearer ${token}` } : {}),
                },
                credentials: 'include',
            });

            if (!res.ok) throw new Error(`Server error: ${res.status}`);

            const data = await res.json();

            // Filter: only show users that are assigned_by the logged-in userId
            // and exclude super_admin rows (agents typically have role = 'agent' or 'client')
            const filtered = Array.isArray(data)
                ? data.filter(u =>
                    String(u.assigned_by) === String(userId) &&
                    !['super_admin', 'super-admin'].includes(u.role)
                )
                : [];

            // Normalise to the shape the table expects
            const normalised = filtered.map(u => ({
                id: u.id,
                name: u.name,
                phone: u.mobile || u.number || '—',
                email: u.email,
                RegistrationDate: u.createdAt
                    ? new Date(u.createdAt).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })
                    : '—',
                ExpiryDate: u.expiry
                    ? new Date(u.expiry).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })
                    : '—',
                AllChatAssign: false,
                role: u.role,
                status: u.status,
            }));

            setUsers(normalised);
        } catch (err) {
            console.error('Failed to fetch agents:', err);
            setFetchError(err.message || 'Failed to load agents');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAgents();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ─── Filter logic (client-side) ───────────────────────────────────────────
    const [appliedName, setAppliedName] = useState('');
    const [appliedNumber, setAppliedNumber] = useState('');

    const applyFilter = () => {
        setAppliedName(filterName.trim().toLowerCase());
        setAppliedNumber(filterNumber.trim());
        setcurrentPage(1);
    };

    const clearFilter = () => {
        setFilterName('');
        setFilterNumber('');
        setAppliedName('');
        setAppliedNumber('');
        setcurrentPage(1);
    };

    const displayedUsers = users.filter(u => {
        const nameOk = !appliedName || u.name.toLowerCase().includes(appliedName);
        const numOk = !appliedNumber || u.phone.includes(appliedNumber);
        return nameOk && numOk;
    });

    const indexoflastuser = currentPage * usersperpage;
    const indexoffirstuser = indexoflastuser - usersperpage;
    const filteruser = displayedUsers.slice(indexoffirstuser, indexoflastuser);
    const totalpages = Math.max(1, Math.ceil(displayedUsers.length / usersperpage));

    // ─── Toggle AllChatAssign ─────────────────────────────────────────────────
    const chatAssign = (id) => {
        setUsers(prev =>
            prev.map(u => u.id === id ? { ...u, AllChatAssign: !u.AllChatAssign } : u)
        );
    };

    // ─── Delete agent (soft delete via API) ──────────────────────────────────
    const deleteitem = async (id) => {
        if (!window.confirm('Are you sure you want to delete this agent?')) return;
        try {
            const res = await fetch(`/api/client/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token ? { Authorization: `Bearer ${token}` } : {}),
                },
                credentials: 'include',
            });
            if (!res.ok) throw new Error(`Delete failed: ${res.status}`);
            setUsers(prev => prev.filter(u => u.id !== id));
        } catch (err) {
            alert('Failed to delete agent: ' + err.message);
        }
    };

    // ─── Configurations modal helpers ─────────────────────────────────────────
    function addAttributes() {
        if (!Attribute.trim()) return;
        setConfigurations(prev => [
            ...prev,
            { id: prev.length + 1, Attribute, Status },
        ]);
        setAttribute('');
        setChannel('');
        setopen(false);
    }

    // ─── Add Agent form ───────────────────────────────────────────────────────
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        const { AgentName, password, mobile, email, expiryDate } = formData;
        if (!AgentName || !password || !mobile || !email || !expiryDate) {
            alert('All fields are required!');
            return;
        }

        setAddLoading(true);
        try {
            const res = await fetch('/api/client', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token ? { Authorization: `Bearer ${token}` } : {}),
                },
                credentials: 'include',
                body: JSON.stringify({
                    name: AgentName,
                    password,
                    Mobile: mobile,
                    email,
                    Expiry: expiryDate,
                    accountType: 'agent',
                    AssignedBy: userId,
                    status: 'Active',
                }),
            });

            if (!res.ok) {
                const err = await res.json();
                throw new Error(err.error || `Error ${res.status}`);
            }

            setAddAgentOpen(false);
            setFormData(initialState);
            await fetchAgents(); // refresh table
        } catch (err) {
            alert('Failed to add agent: ' + err.message);
        } finally {
            setAddLoading(false);
        }
    };

    // ─── Render ───────────────────────────────────────────────────────────────
    return (
        <>
            <div className='px-2 dark:bg-[#121519] h-[100vh] px-4'>
                {/* Header */}
                <div className='border-b-[1px] border-[#cfcdcd] pb-1'>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>Agent List</h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>
                        <span>Home</span><IoIosArrowForward /><span>Agent List</span>
                    </div>
                </div>

                {/* Add Agent button */}
                <button
                    onClick={() => setAddAgentOpen(true)}
                    className='bg-[#448c74] text-[#fff] text-[13px] font-semibold flex items-center gap-2 rounded-md p-2 mt-2'>
                    <RiAddLargeFill className='font-bold text-[16px]' />
                    Add Agent
                </button>

                {/* Filter bar */}
                <div
                    onClick={() => setshowfilter(!showfilter)}
                    className='w-[100%] flex justify-between px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4 cursor-pointer'>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff]'>
                        <RiCollapseDiagonalLine />
                        Filter Records
                    </div>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff]'>
                        {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                    </div>
                </div>

                {showfilter && (
                    <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519] z-20'>
                        <div className='w-[100%] flex flex-wrap gap-4'>
                            <div className='w-full sm:w-[48%] lg:w-[32%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Agent Name:</label>
                                <input
                                    value={filterName}
                                    onChange={e => setFilterName(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    placeholder='Enter Agent Name'
                                    type="text"
                                />
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[32%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Agent Number:</label>
                                <input
                                    value={filterNumber}
                                    onChange={e => setFilterNumber(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    placeholder='Enter Mobile Number'
                                    type="text"
                                />
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[32%] flex items-center gap-1 mt-4'>
                                <button
                                    onClick={e => { e.stopPropagation(); applyFilter(); }}
                                    className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'>
                                    <FaFilter /><span className='text-[12px] font-bold'>Filter</span>
                                </button>
                                <button
                                    onClick={e => { e.stopPropagation(); clearFilter(); }}
                                    className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'>
                                    <TbReload /><span className='text-[12px] font-bold'>Clear Filter</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Table */}
                <table className="w-full overflow-hidden border-[1px] border-[#dee2e6] relative">
                    <thead>
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            {['Name', 'Number', 'Email', 'Registration Date', 'Account Expiry Date', 'All Chat Assign', 'Action'].map(h => (
                                <th key={h} className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                                    <div className="flex justify-between items-center gap-2">
                                        <span className='text-[11px] text-[#576071] dark:text-[#fff]'>{h}</span>
                                        <button type="button" className="text-gray-500 hover:text-black"><TbArrowsSort /></button>
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan="7" className="p-3 text-[11px]">Loading agents…</td>
                            </tr>
                        ) : fetchError ? (
                            <tr className="text-center bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan="7" className="p-3 text-[11px] text-red-500">
                                    {fetchError} —{' '}
                                    <button onClick={fetchAgents} className="underline text-[#3f7fca]">retry</button>
                                </td>
                            </tr>
                        ) : filteruser.length > 0 ? (
                            filteruser.map(user => (
                                <tr
                                    key={user.id}
                                    className="text-gray-500 odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#edf1f5]">
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">{user.name}</td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">{user.phone}</td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">{user.email}</td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">{user.RegistrationDate}</td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">{user.ExpiryDate}</td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">
                                        <button
                                            onClick={() => chatAssign(user.id)}
                                            className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${user.AllChatAssign ? 'bg-[#37715d]' : 'bg-[#b4bbc3]'}`}>
                                            <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${user.AllChatAssign ? 'translate-x-[13px]' : ''}`}></div>
                                        </button>
                                    </td>
                                    <td className="p-1 text-[11px] border-[1px] flex gap-1 items-center border-[#dee2e6] dark:text-[#fff]">
                                        <button
                                            onClick={() => deleteitem(user.id)}
                                            className='p-1 border-[1px] border-[#ed5050] rounded-md text-[#ed5050] hover:text-[#fff] hover:bg-[#ed5050]'>
                                            <MdDelete />
                                        </button>
                                        <button
                                            onClick={() => setopen(true)}
                                            className='p-1 border-[1px] border-[#448c74] rounded-md text-[#448c74] hover:text-[#fff] hover:bg-[#448c74]'>
                                            <FaCogs />
                                        </button>
                                        <button className='p-1 border-[1px] border-[#121519] rounded-md text-[#121519] hover:text-[#fff] hover:bg-[#121519]'>
                                            <PiSignInBold />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan="7" className="p-1 text-[11px]">No data found</td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* Pagination */}
                <div className='flex justify-between w-[100%]'>
                    <p className='text-[11px] text-[#3f7fc8] mt-2'>
                        Showing {displayedUsers.length === 0 ? 0 : indexoffirstuser + 1} to {Math.min(indexoflastuser, displayedUsers.length)} of {displayedUsers.length} records
                    </p>
                    <div className="flex justify-center mt-4 space-x-3 relative z-0">
                        <button
                            disabled={currentPage === 1}
                            onClick={() => setcurrentPage(prev => prev - 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition">
                            Prev
                        </button>
                        <p className='text-[11px] text-[#3f7fc8] mt-2'>{currentPage} page of {totalpages} pages</p>
                        <button
                            disabled={currentPage === totalpages}
                            onClick={() => setcurrentPage(prev => prev + 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition">
                            Next
                        </button>
                    </div>
                </div>
            </div>

            {/* ── Configurations Modal ── */}
            <AgentChatConfigurationsModal isOpen={open} onClose={() => setopen(false)} heading='Agent Chat Configurations'>
                <div className='border-t-[1px] border-[#e3e9ef] w-[100%]'>
                    <button
                        onClick={() => setshowAttributes(true)}
                        className='bg-[#448c74] text-[#fff] text-[13px] font-semibold flex items-center gap-2 rounded-md p-2 mt-2'>
                        <RiAddLargeFill className='font-bold text-[16px]' />
                        Add Attribute
                    </button>
                </div>

                {ShowAttributes && (
                    <div className='border-[1px] p-2 border-[#dee2e6] rounded-md mt-2'>
                        <div className='w-[100%] py-2 bg-[#f6f9fc] flex justify-center items-center'>
                            <h1 className='text-[#000] text-[16px] font-semibold'>User Attributes</h1>
                        </div>
                        <div className='mt-2'>
                            <label className='text-[#121519] text-[13px] font-semibold'>Channel</label>
                            <select
                                value={Channel}
                                onChange={e => setChannel(e.target.value)}
                                className='border-[1px] text-[#121519] border-[#d4cfcf] w-[100%] rounded-lg p-1 outline-none'>
                                <option value="">Select Channel</option>
                            </select>
                        </div>
                        <div className='mt-2'>
                            <label className='text-[#121519] text-[13px] font-semibold'>Attribute</label>
                            <input
                                type="text"
                                value={Attribute}
                                onChange={e => setAttribute(e.target.value)}
                                className='border-[1px] border-[#d4cfcf] w-[100%] rounded-lg p-1 outline-none'
                                placeholder='Var1'
                            />
                        </div>
                        <div className='mt-2 flex gap-2 items-center'>
                            <span className='text-[#121519] text-[13px] font-semibold'>Status</span>
                            <button
                                onClick={() => setStatus(!Status)}
                                className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${Status ? 'bg-[#37715d]' : 'bg-[#b4bbc3]'}`}>
                                <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${Status ? 'translate-x-[13px]' : ''}`}></div>
                            </button>
                        </div>
                        <div className='w-[100%] flex items-center justify-end'>
                            <button
                                onClick={addAttributes}
                                className='bg-[#37715d] p-2 rounded-md text-[#fff] text-[12px] flex items-center gap-1 font-semibold'>
                                <IoSaveSharp />Save
                            </button>
                        </div>
                    </div>
                )}

                <table className="w-full overflow-hidden border-[1px] border-[#dee2e6] relative mt-4">
                    <thead>
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            {['Attributes', 'Created Date', 'Status', 'Action'].map(h => (
                                <th key={h} className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                                    <div className="flex justify-between items-center gap-2">
                                        <span className='text-[11px] text-[#576071] dark:text-[#fff]'>{h}</span>
                                        <button type="button" className="text-gray-500 hover:text-black"><TbArrowsSort /></button>
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {Configurations.length > 0 ? (
                            Configurations.map(cfg => (
                                <tr key={cfg.id} className="text-gray-500 odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#edf1f5]">
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">{cfg.Attribute}</td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">—</td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">{cfg.Status ? 'Active' : 'Inactive'}</td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">—</td>
                                </tr>
                            ))
                        ) : (
                            <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan="4" className="p-1 text-[11px]">No data found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </AgentChatConfigurationsModal>

            {/* ── Add Agent Modal ── */}
            <AddAgent isOpen={AddAgentOpen} onClose={() => setAddAgentOpen(false)} heading='Add Agent'>
                <div className='py-1 px-4 w-[100%] dark:bg-[#121519]'>
                    <div className='w-[100%] flex flex-wrap gap-2'>

                        <div className='w-full flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Agent Name</label>
                            <input
                                name='AgentName'
                                value={formData.AgentName}
                                onChange={handleChange}
                                placeholder='Enter Agent name'
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                type="text"
                            />
                        </div>

                        <div className='w-full flex gap-1'>
                            <div className='flex flex-col w-[100%]'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Password</label>
                                <div className='flex justify-between border-[#d4cfcf] border-[1px] rounded-md w-[100%] py-1'>
                                    <input
                                        name='password'
                                        value={formData.password}
                                        onChange={handleChange}
                                        placeholder='Enter Password'
                                        className='text-[#454546] text-[12px] font-semibold px-2 py-1 outline-none dark:bg-[#121519] dark:text-[#fff] w-full'
                                        type={showpasword ? 'text' : 'password'}
                                    />
                                    <div className='border-l-[1px] border-[#d4cfcf] p-2 text-[#454546] cursor-pointer'>
                                        {showpasword
                                            ? <FaEye onClick={() => setshowpasword(false)} />
                                            : <FaEyeSlash onClick={() => setshowpasword(true)} />}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='w-full flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Mobile Number</label>
                            <input
                                name='mobile'
                                value={formData.mobile}
                                onChange={handleChange}
                                placeholder='Enter Mobile Number'
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                type="text"
                            />
                        </div>

                        <div className='w-full flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Email ID</label>
                            <input
                                name='email'
                                value={formData.email}
                                onChange={handleChange}
                                placeholder='Enter Email Address'
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                type="text"
                            />
                        </div>

                        <div className='w-full flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Account Expiry Date</label>
                            <input
                                name='expiryDate'
                                value={formData.expiryDate}
                                onChange={handleChange}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                type="date"
                            />
                        </div>

                        <div className='w-full flex items-center justify-end gap-1 mt-4'>
                            <button
                                onClick={handleSubmit}
                                disabled={addLoading}
                                className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 gap-2 bg-[#37715d] text-[#fff] w-full sm:w-auto disabled:opacity-60'>
                                <span className='text-[12px] font-bold'>{addLoading ? 'Saving…' : 'Save'}</span>
                            </button>
                            <button
                                onClick={() => setAddAgentOpen(false)}
                                className='flex items-center justify-end border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'>
                                <span className='text-[12px] font-bold'>Close</span>
                            </button>
                        </div>

                    </div>
                </div>
            </AddAgent>
        </>
    );
}

export default AgentList;